
import React from 'react';
import Introduction from './Introduction';
import SecurityChallenges from './SecurityChallenges';
import BestPractices from './BestPractices';
import TechnologySolutions from './TechnologySolutions';
import Implementation from './Implementation';
import Conclusion from './Conclusion';

const SecureDocumentManagement: React.FC = () => {
  return (
    <article className="blog-article">
      <Introduction />
      
      <h2 id="security-challenges" className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Understanding Security Challenges for Accounting Firms</h2>
      <SecurityChallenges />
      
      <h2 id="best-practices" className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Essential Document Management Best Practices</h2>
      <BestPractices />
      
      <h2 id="technology-solutions" className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Technology Solutions for Secure Document Management</h2>
      <TechnologySolutions />
      
      <h2 id="implementation" className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Implementation Steps for Your CPA Firm</h2>
      <Implementation />
      
      <Conclusion />
    </article>
  );
};

export default SecureDocumentManagement;
